import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/camps/load',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/camps/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/camps/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/camps/delete',
    method: 'post',
    data
  })
}

